<script>
  import LogoURL from "../assets/icons/logo.svg";
  import HelpURL from "../assets/icons/help.svg";
</script>

<header class="root">
  <div><img src={LogoURL} alt="Fireblocks logo" /></div>
  <div class="links">
    <a class="helpCenter" href="https://support.fireblocks.io/hc/en-us">
      <img src={HelpURL} alt="Help center" />
    </a>
  </div>
</header>

<style>
  .root {
    padding: 22px 40px;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-family: Ubuntu;
  }

  .links {
    display: flex;
    align-items: center;
    gap: 70px;
  }

  .helpCenter {
    display: flex;
    align-items: center;
    gap: 12px;
  }
</style>
